import { Feature, PlanInterval } from '../../models';

const getIntervalName = (
  planInterval: PlanInterval,
) => PlanInterval.getPlanIntervalName(planInterval).toLowerCase();

export const getPlanId = (
  feature: Feature,
  planInterval: PlanInterval,
): string => {
  const intervalName = getIntervalName(planInterval);
  switch (feature) {
    case Feature.TESTOPS_PLATFORM:
      return `testops_platform_${intervalName}`;
    case Feature.PER_USER_KSE:
      return `kse_per-user_${intervalName}`;
    case Feature.FLOATING_KSE:
      return `kse_floating-user_${intervalName}`;
    case Feature.UNLIMITED_ENGINE:
      return `kre_floating_${intervalName}`;
    case Feature.TESTCLOUD_SESSION_WEB:
      return `testcloud_session_web_${intervalName}`;
    case Feature.TESTCLOUD_SESSION_WEB_DESKTOP:
      return `testcloud_session_webdesktop_${intervalName}`;
    case Feature.TESTCLOUD_SESSION_CROSS_BROWSER:
      return `testcloud_session_crossbrowser_${intervalName}`;
    case Feature.TESTCLOUD_SESSION_MOBILE_APP:
      return `testcloud_session_mobileapp_${intervalName}`;
    case Feature.TESTCLOUD_SESSION_LIVE_TESTING:
      return `testcloud_session_livetesting_${intervalName}`;
    case Feature.VISUAL_TESTING_PRO:
      return `visual_testing_pro_${intervalName}`;
    default:
      return '';
  }
};

export const formatMessageRecurly = (message: string) => message.replaceAll(/[^a-zA-Z0-9\s.]/g, '');

export const insertIf = (condition: any, ...elements: any) => (condition ? elements : []);

const trackingErrorTypeMapper: { [key: string]: string; } = {
  matches: 'invalid',
  required: 'required',
};

export const formatErrorTrackingMethod = (fieldName: string, errorType: string) => `${fieldName}_is_${trackingErrorTypeMapper[errorType] ?? 'invalid'}`;
